import React from "react";
import { Sidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar";
import "../sidebar/TunasSidebar.css";
import { Link, useNavigate } from "react-router-dom";
import {
  FaHome,
  FaClipboardList,
  FaFileMedicalAlt,
  FaSyringe,
  FaPersonBooth,
  FaListAlt,
  FaCartPlus,
  FaWarehouse,
  FaBookMedical,
  FaDatabase,
  FaCashRegister,
  FaPrescriptionBottleAlt,
} from "react-icons/fa";
import { FaUserDoctor } from "react-icons/fa6";
import { BsBank2, BsCash } from "react-icons/bs";
import {
  MdLocalPharmacy,
  MdCategory,
  MdAdUnits,
  MdWork,
  MdLogout,
  MdProductionQuantityLimits,
  MdAccountCircle,
} from "react-icons/md";
import { FcExpired } from "react-icons/fc";
import logoIcon from "../../icon/apotek-tunas-logo.png";

function TunasSideBar({ selected }) {
  const listDoctorPath = ["/daftar-dokter", "/poli", "/tindakan"];
  const listPatientPath = ["/daftar-pasien"];
  const listProductPath = [
    "/daftar-produk",
    "/produk-kategori",
    "/produk-unit",
    "/produk-expired",
  ];
  const listSupplierPath = ["/daftar-supplier"];
  const listPartnerPath = ["/daftar-partner"];
  const listStaffPath = ["/daftar-staf"];
  const listBankPath = ["/daftar-bank"];
  const listPharmacySellingPath = ["/beli-obat", "/beli-obat-rekanan"];
  const listPharmacyBuyingPath = [
    "/produk-invoice",
    "/add-produk-invoice",
    "/invoice-belum-bayar",
  ];
  const listClinicPath = ["/transaksi-tindakan-medis"];
  const listPharmacyTransactionPath = [
    "/apotek-penjualan-perhari",
    "/apotek-penjualan-perbulan",
    "/apotek-penjualan-pertahun",
    "/distribusi-obat",
    "/retur",
  ];
  const listClinicTransactionPath = [
    "/klinik-penjualan-perhari",
    "/klinik-penjualan-perbulan",
    "/klinik-penjualan-pertahun",
    "/data-transaksi-tindakan-medis",
  ];

  const listClinicPartnerTransactionPath = [
    "/klinik-penjualan-perhari-rekanan",
    "/klinik-penjualan-perbulan-rekanan",
    "/klinik-penjualan-pertahun-rekanan",
    "/klinik-penjualan-rentang-rekanan",
  ];

  const listReportPharmacyFinancePath = ["/apotek-profit"];
  const listReportMedicalTreatmentRecordData = [
    "/data-transaksi-tindakan-medis",
  ];

  const userData = JSON.parse(localStorage.getItem("user_data"));
  const navigate = useNavigate();

  const isMasterMenuOpen = () => {
    return (
      isDoctorMenuOpen() ||
      isPatientMenuOpen() ||
      isProductMenuOpen() ||
      isSupplierMenuOpen() ||
      isPartnerMenuOpen() ||
      isStaffMenuOpen() ||
      isBankMenuOpen()
    );
  };

  const isClinicMenuOpen = () => {
    return (
      isClinicTransactionMenuOpen() ||
      isClinicTransactionOpen() ||
      isClinicPartnerTransactionMenuOpen()
    );
  };

  const isPharmacyMenuOpen = () => {
    return (
      isPharmacyBuyingMenuOpen() ||
      isPharmacySellingMenuOpen() ||
      isPharmacyTransactionMenuOpen()
    );
  };

  const isDoctorMenuOpen = () => {
    return listDoctorPath.includes(selected);
  };

  const isPatientMenuOpen = () => {
    return listPatientPath.includes(selected);
  };

  const isProductMenuOpen = () => {
    return listProductPath.includes(selected);
  };

  const isSupplierMenuOpen = () => {
    return listSupplierPath.includes(selected);
  };

  const isPartnerMenuOpen = () => {
    return listPartnerPath.includes(selected);
  };

  const isStaffMenuOpen = () => {
    return listStaffPath.includes(selected);
  };

  const isBankMenuOpen = () => {
    return listBankPath.includes(selected);
  };

  const isClinicTransactionOpen = () => {
    return listClinicPath.includes(selected);
  };

  const isPharmacyTransactionMenuOpen = () => {
    return listPharmacyTransactionPath.includes(selected);
  };

  const isPharmacyBuyingMenuOpen = () => {
    return listPharmacyBuyingPath.includes(selected);
  };

  const isPharmacySellingMenuOpen = () => {
    return listPharmacySellingPath.includes(selected);
  };

  const isClinicTransactionMenuOpen = () => {
    return listClinicTransactionPath.includes(selected);
  };

  const isClinicPartnerTransactionMenuOpen = () => {
    return listClinicPartnerTransactionPath.includes(selected);
  };

  const isReportMedicalTreatmentMenuOpen = () => {
    return listReportMedicalTreatmentRecordData.includes(selected);
  };

  const isReportPharmacyFinanceOpen = () => {
    return listReportPharmacyFinancePath.includes(selected);
  };

  const handleLogout = () => {
    localStorage.clear();
    navigate("/login", { replace: true });
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100vh" }}>
      <div
        style={{ padding: 16, backgroundColor: "#f8f9fa", textAlign: "center" }}
      >
        <img
          src={logoIcon}
          alt="Sidebar Header"
          style={{
            width: "218px",
            height: "auto", // Keeps aspect ratio intact
            objectFit: "cover",
            backgroundColor: "#f8f9fa", // Fallback background color
          }}
        />
      </div>
      <div style={{ flex: 1 }}>
        <Sidebar width="272px">
          <Menu
            menuItemStyles={{
              button: ({ active }) => ({
                backgroundColor: active ? "#007bff" : "#f8f9fa",
                color: active ? "#ffffff" : "#333333",
                transition: "all 0.1s ease-in-out",
                "&:hover": {
                  backgroundColor: "#335B8C",
                  color: "white",
                },
              }),
            }}
          >
            <MenuItem icon={<MdAccountCircle />}>
              {(userData != null && userData.staff_name) || "Silahkan Login"}
            </MenuItem>
            <MenuItem
              icon={<FaHome />}
              component={<Link to="/dashboard" className="menu-item-style" />}
              active={selected === "/dashboard"}
            >
              Dashboard
            </MenuItem>
            {userData != null && userData.staff_system_role === "KASIR" && (
              <SubMenu
                label="Master"
                icon={<FaDatabase />}
                defaultOpen={isMasterMenuOpen()}
              >
                <SubMenu
                  label="Pasien"
                  icon={<FaPersonBooth />}
                  defaultOpen={isPatientMenuOpen()}
                >
                  <MenuItem
                    icon={<FaListAlt />}
                    component={
                      <Link to="/daftar-pasien" className="menu-item-style" />
                    }
                    active={selected === "/daftar-pasien"}
                  >
                    Daftar Pasien
                  </MenuItem>
                </SubMenu>
              </SubMenu>
            )}
            {userData != null &&
              (userData.staff_system_role === "ADMIN" ||
                userData.staff_system_role === "MANAGER" ||
                userData.staff_system_role === "WAREHOUSE" ||
                userData.staff_system_role === "SUPERVISOR") && (
                <SubMenu
                  label="Master"
                  icon={<FaDatabase />}
                  defaultOpen={isMasterMenuOpen()}
                >
                  <SubMenu
                    label="Dokter"
                    icon={<FaUserDoctor />}
                    defaultOpen={isDoctorMenuOpen()}
                  >
                    <MenuItem
                      icon={<FaClipboardList />}
                      component={
                        <Link to="/daftar-dokter" className="menu-item-style" />
                      }
                      active={selected === "/daftar-dokter"}
                    >
                      Daftar Dokter
                    </MenuItem>
                    <MenuItem
                      icon={<FaFileMedicalAlt />}
                      component={
                        <Link to="/poli" className="menu-item-style" />
                      }
                      active={selected === "/poli"}
                    >
                      Poli
                    </MenuItem>
                    <MenuItem
                      icon={<FaSyringe />}
                      component={
                        <Link to="/tindakan" className="menu-item-style" />
                      }
                      active={selected === "/tindakan"}
                    >
                      Tindakan
                    </MenuItem>
                  </SubMenu>
                  <SubMenu
                    label="Pasien"
                    icon={<FaPersonBooth />}
                    defaultOpen={isPatientMenuOpen()}
                  >
                    <MenuItem
                      icon={<FaListAlt />}
                      component={
                        <Link to="/daftar-pasien" className="menu-item-style" />
                      }
                      active={selected === "/daftar-pasien"}
                    >
                      Daftar Pasien
                    </MenuItem>
                  </SubMenu>
                  <SubMenu
                    label="Produk"
                    icon={<MdLocalPharmacy />}
                    defaultOpen={isProductMenuOpen()}
                  >
                    <MenuItem
                      icon={<FaCartPlus />}
                      component={
                        <Link to="/daftar-produk" className="menu-item-style" />
                      }
                      active={selected === "/daftar-produk"}
                    >
                      Produk
                    </MenuItem>
                    <MenuItem
                      icon={<MdCategory />}
                      component={
                        <Link
                          to="/produk-kategori"
                          className="menu-item-style"
                        />
                      }
                      active={selected === "/produk-kategori"}
                    >
                      Produk Kategori
                    </MenuItem>
                    <MenuItem
                      icon={<MdAdUnits />}
                      component={
                        <Link to="/produk-unit" className="menu-item-style" />
                      }
                      active={selected === "/produk-unit"}
                    >
                      Produk Unit
                    </MenuItem>
                    <MenuItem
                      icon={<FcExpired />}
                      component={
                        <Link
                          to="/produk-expired"
                          className="menu-item-style"
                        />
                      }
                      active={selected === "/produk-expired"}
                    >
                      Produk Expired
                    </MenuItem>
                  </SubMenu>
                  <SubMenu
                    label="Supplier"
                    icon={<FaWarehouse />}
                    defaultOpen={isSupplierMenuOpen()}
                  >
                    <MenuItem
                      icon={<FaClipboardList />}
                      component={
                        <Link
                          to="/daftar-supplier"
                          className="menu-item-style"
                        />
                      }
                      active={selected === "/daftar-supplier"}
                    >
                      Daftar Supplier
                    </MenuItem>
                  </SubMenu>
                  <SubMenu
                    label="Partner"
                    icon={<FaBookMedical />}
                    defaultOpen={isPartnerMenuOpen()}
                  >
                    <MenuItem
                      icon={<FaClipboardList />}
                      component={
                        <Link
                          to="/daftar-partner"
                          className="menu-item-style"
                        />
                      }
                      active={selected === "/daftar-partner"}
                    >
                      Daftar Partner
                    </MenuItem>
                  </SubMenu>
                  {userData != null &&
                    (userData.staff_system_role === "ADMIN" ||
                      userData.staff_system_role === "MANAGER") && (
                      <SubMenu
                        label="Staf"
                        icon={<MdWork />}
                        defaultOpen={isStaffMenuOpen()}
                      >
                        <MenuItem
                          icon={<FaClipboardList />}
                          component={
                            <Link
                              to="/daftar-staf"
                              className="menu-item-style"
                            />
                          }
                          active={selected === "/daftar-staf"}
                        >
                          Daftar Staff
                        </MenuItem>
                      </SubMenu>
                    )}
                  <SubMenu
                    label="Bank"
                    icon={<BsBank2 />}
                    defaultOpen={isBankMenuOpen()}
                  >
                    <MenuItem
                      icon={<FaClipboardList />}
                      component={
                        <Link to="/daftar-bank" className="menu-item-style" />
                      }
                      active={selected === "/daftar-bank"}
                    >
                      Daftar Bank
                    </MenuItem>
                  </SubMenu>
                </SubMenu>
              )}
            <SubMenu
              label="Apotek"
              icon={<FaPrescriptionBottleAlt />}
              defaultOpen={isPharmacyMenuOpen()}
            >
              {userData != null &&
                (userData.staff_system_role === "ADMIN" ||
                  userData.staff_system_role === "MANAGER" ||
                  userData.staff_system_role === "KASIR" ||
                  userData.staff_system_role === "SUPERVISOR") && (
                  <SubMenu
                    label="Penjualan"
                    icon={<FaCashRegister />}
                    defaultOpen={isPharmacySellingMenuOpen()}
                  >
                    <MenuItem
                      icon={<FaCashRegister />}
                      component={
                        <Link to="/beli-obat" className="menu-item-style" />
                      }
                      active={selected === "/beli-obat"}
                    >
                      Obat Umum
                    </MenuItem>
                    <MenuItem
                      icon={<FaCashRegister />}
                      component={
                        <Link
                          to="/beli-obat-rekanan"
                          className="menu-item-style"
                        />
                      }
                      active={selected === "/beli-obat-rekanan"}
                    >
                      Obat Rekanan
                    </MenuItem>
                  </SubMenu>
                )}
              {userData != null &&
                (userData.staff_system_role === "ADMIN" ||
                  userData.staff_system_role === "MANAGER" ||
                  userData.staff_system_role === "WAREHOUSE") && (
                  <SubMenu
                    label="Pembelian"
                    icon={<FaPrescriptionBottleAlt />}
                    defaultOpen={isPharmacyBuyingMenuOpen()}
                  >
                    <MenuItem
                      icon={<FaClipboardList />}
                      component={
                        <Link
                          to="/produk-invoice"
                          className="menu-item-style"
                        />
                      }
                      active={selected === "/produk-invoice"}
                    >
                      Produk Invoice
                    </MenuItem>
                    <MenuItem
                      icon={<FaClipboardList />}
                      component={
                        <Link
                          to="/invoice-belum-bayar"
                          className="menu-item-style"
                        />
                      }
                      active={selected === "/invoice-belum-bayar"}
                    >
                      Pembayaran Invoice
                    </MenuItem>
                  </SubMenu>
                )}
              {userData != null &&
                (userData.staff_system_role === "ADMIN" ||
                  userData.staff_system_role === "MANAGER" ||
                  userData.staff_system_role === "SUPERVISOR") && (
                  <SubMenu
                    label="Laporan"
                    icon={<FaCashRegister />}
                    defaultOpen={isPharmacyTransactionMenuOpen()}
                  >
                    <MenuItem
                      icon={<BsCash />}
                      component={
                        <Link
                          to="/apotek-penjualan-perhari"
                          className="menu-item-style"
                        />
                      }
                      active={selected === "/apotek-penjualan-perhari"}
                    >
                      Penjualan Perhari
                    </MenuItem>

                    {userData.staff_system_role !== "SUPERVISOR" && (
                      <>
                        <MenuItem
                          icon={<BsCash />}
                          component={
                            <Link
                              to="/apotek-penjualan-perbulan"
                              className="menu-item-style"
                            />
                          }
                          active={selected === "/apotek-penjualan-perbulan"}
                        >
                          Penjualan Perbulan
                        </MenuItem>
                        <MenuItem
                          icon={<BsCash />}
                          component={
                            <Link
                              to="/apotek-penjualan-pertahun"
                              className="menu-item-style"
                            />
                          }
                          active={selected === "/apotek-penjualan-pertahun"}
                        >
                          Penjualan Pertahun
                        </MenuItem>
                        {/* <MenuItem
                          icon={<MdProductionQuantityLimits />}
                          component={
                            <Link
                              to="/distribusi-obat"
                              className="menu-item-style"
                            />
                          }
                          active={selected === "/distribusi-obat"}
                        >
                          Distribusi Stok
                        </MenuItem> */}
                      </>
                    )}

                    {userData.staff_system_role === "ADMIN" ||
                      userData.staff_system_role === "MANAGER" ? (
                      <MenuItem
                        icon={<MdProductionQuantityLimits />}
                        component={
                          <Link to="/retur" className="menu-item-style" />
                        }
                        active={selected === "/retur"}
                      >
                        Retur
                      </MenuItem>
                    ) : null}
                  </SubMenu>
                )}

              {userData !== null &&
                (userData.staff_system_role === "ADMIN" ||
                  userData.staff_system_role === "MANAGER" ||
                  userData.staff_system_role === "SUPERVISOR") && (
                  <MenuItem
                    icon={<MdProductionQuantityLimits />}
                    component={
                      <Link to="/distribusi-obat" className="menu-item-style" />
                    }
                    active={selected === "/distribusi-obat"}
                  >
                    Distribusi Stok
                  </MenuItem>
                )}

            </SubMenu>
            {userData != null &&
              (userData.staff_system_role === "ADMIN" ||
                userData.staff_system_role === "MANAGER" ||
                userData.staff_system_role === "KASIR" ||
                userData.staff_system_role === "SUPERVISOR") && (
                <SubMenu
                  label="Klinik"
                  icon={<FaUserDoctor />}
                  defaultOpen={isClinicMenuOpen()}
                >
                  <SubMenu
                    label="Penjualan"
                    icon={<FaCashRegister />}
                    defaultOpen={isClinicTransactionOpen()}
                  >
                    <MenuItem
                      icon={<MdLocalPharmacy />}
                      component={
                        <Link
                          to="/transaksi-tindakan-medis"
                          className="menu-item-style"
                        />
                      }
                      active={selected === "/transaksi-tindakan-medis"}
                    >
                      Tindakan Dokter
                    </MenuItem>
                  </SubMenu>
                  {userData.staff_system_role !== "KASIR" && (
                    <>
                      <SubMenu
                        label="Laporan"
                        icon={<FaCashRegister />}
                        defaultOpen={isClinicTransactionMenuOpen()}
                      >
                        <MenuItem
                          icon={<BsCash />}
                          component={
                            <Link
                              to="/klinik-penjualan-perhari"
                              className="menu-item-style"
                            />
                          }
                          active={selected === "/klinik-penjualan-perhari"}
                        >
                          Penjualan Perhari
                        </MenuItem>
                        {userData.staff_system_role !== "SUPERVISOR" && (
                          <>
                            <MenuItem
                              icon={<BsCash />}
                              component={
                                <Link
                                  to="/klinik-penjualan-perbulan"
                                  className="menu-item-style"
                                />
                              }
                              active={selected === "/klinik-penjualan-perbulan"}
                            >
                              Penjualan Perbulan
                            </MenuItem>
                            <MenuItem
                              icon={<BsCash />}
                              component={
                                <Link
                                  to="/klinik-penjualan-pertahun"
                                  className="menu-item-style"
                                />
                              }
                              active={selected === "/klinik-penjualan-pertahun"}
                            >
                              Penjualan Pertahun
                            </MenuItem>
                          </>
                        )}
                      </SubMenu>
                      <SubMenu
                        label="Laporan Rekanan"
                        icon={<FaCashRegister />}
                        defaultOpen={isClinicPartnerTransactionMenuOpen()}
                      >
                        {userData.staff_system_role !== "SUPERVISOR" && (
                          <>
                            <MenuItem
                              icon={<BsCash />}
                              component={
                                <Link
                                  to="/klinik-penjualan-perhari-rekanan"
                                  className="menu-item-style"
                                />
                              }
                              active={
                                selected === "/klinik-penjualan-perhari-rekanan"
                              }
                            >
                              Penjualan Perhari
                            </MenuItem>

                            <MenuItem
                              icon={<BsCash />}
                              component={
                                <Link
                                  to="/klinik-penjualan-perbulan-rekanan"
                                  className="menu-item-style"
                                />
                              }
                              active={
                                selected ===
                                "/klinik-penjualan-perbulan-rekanan"
                              }
                            >
                              Penjualan Perbulan
                            </MenuItem>
                            <MenuItem
                              icon={<BsCash />}
                              component={
                                <Link
                                  to="/klinik-penjualan-pertahun-rekanan"
                                  className="menu-item-style"
                                />
                              }
                              active={
                                selected ===
                                "/klinik-penjualan-pertahun-rekanan"
                              }
                            >
                              Penjualan Pertahun
                            </MenuItem>
                          </>
                        )}
                        <MenuItem
                          icon={<BsCash />}
                          component={
                            <Link
                              to="/klinik-penjualan-rentang-rekanan"
                              className="menu-item-style"
                            />
                          }
                          active={
                            selected === "/klinik-penjualan-rentang-rekanan"
                          }
                        >
                          Rentang Hari
                        </MenuItem>
                      </SubMenu>
                    </>
                  )}
                </SubMenu>
              )}
            {userData != null &&
              (userData.staff_system_role === "ADMIN" ||
                userData.staff_system_role === "MANAGER") && (
                <SubMenu
                  label="Laporan Keuangan"
                  icon={<BsCash />}
                  defaultOpen={
                    isReportPharmacyFinanceOpen() ||
                    isReportMedicalTreatmentMenuOpen()
                  }
                >
                  <SubMenu
                    label="Apotek"
                    icon={<FaPrescriptionBottleAlt />}
                    defaultOpen={isReportPharmacyFinanceOpen()}
                  >
                    <MenuItem
                      icon={<BsCash />}
                      component={
                        <Link to="/apotek-profit" className="menu-item-style" />
                      }
                      active={selected === "/apotek-profit"}
                    >
                      Profit
                    </MenuItem>
                  </SubMenu>
                  <SubMenu
                    label="Klinik"
                    icon={<FaUserDoctor />}
                    defaultOpen={isReportMedicalTreatmentMenuOpen()}
                  >
                    <MenuItem
                      icon={<BsCash />}
                      component={
                        <Link
                          to="/data-transaksi-tindakan-medis"
                          className="menu-item-style"
                        />
                      }
                      active={selected === "/data-transaksi-tindakan-medis"}
                    >
                      Laporan Tindakan
                    </MenuItem>
                  </SubMenu>
                </SubMenu>
              )}
            <MenuItem icon={<MdLogout />} onClick={handleLogout}>
              Logout
            </MenuItem>
          </Menu>
        </Sidebar>
      </div>
    </div>
  );
}

export default TunasSideBar;
